import React from "react";
import { ChatMessageBase } from "../../molecules/ChatMessageBase/ChatMessageBase";
import { MessageWithActionAndData } from "@me8eon/sessions_messages";
import { MarkdownRenderer } from "@me8eon/markdown_renderers";
import { Icon } from "@me8eon/icons";
import { findWidgetByKey } from "../../../AiWidgets/widgetRepository";
import styles from "./NexthinkRecommendationMessageComponent.module.scss";

type Props = {
    /** Parsed content (`_meta.widget`) of the Nexthink tool message. */
    widgetValues: any;
    /** The assistant text message that accompanies the recommendation, if any. */
    textMessage: MessageWithActionAndData | null;
    isLast: boolean;
    isStreaming?: boolean;
}

/**
 * Renders a Nexthink remediation action as an inline recommendation together
 * with the assistant's answer text, as a single combined chat response
 * (instead of a separate standalone widget bubble).
 */
export const NexthinkRecommendationMessageComponent: React.FC<Props> = ({ widgetValues, textMessage, isLast, isStreaming }) => {
    const WidgetComponent = findWidgetByKey(widgetValues);
    if (!WidgetComponent) return null;

    const text = typeof textMessage?.content === "string" ? textMessage.content : "";

    return (
        <ChatMessageBase
            content={
                <div className={styles.recommendation}>
                    <div
                        className={styles.recommendation__widget}
                        role="region"
                        aria-label="Recommended action"
                    >
                        <WidgetComponent values={widgetValues} />
                    </div>
                    {text.length > 0 && (
                        <div className={styles.recommendation__text}>
                            <MarkdownRenderer
                                value={text}
                                attribute={"assistant"}
                                rootId={crypto.randomUUID()}
                            />
                        </div>
                    )}
                </div>
            }
            variant={"assistant"}
            isLast={isLast}
            disableActions={Boolean(isStreaming)}
        />
    );
};
